<template>
    <div>
        <slot :shop="localValue"></slot>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
    },

    emits: ['update:modelValue'],

    computed: {
        localValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                console.log('updateFilter');
                this.$emit('update:modelValue', value);
            },
        },
    },
};
</script>
